<template>
<b-row class="m-2">
    <b-col>
        <b-form id="form-stream-criteria" @submit="onSubmit">
            <b-row>
                <b-col class="text-right OTbtnContainer" cols="12">
                    <b-button type="button" variant=" OTSecondary" @click="$router.push({name: 'jobs'})">Cancel</b-button>
                    <b-button type="submit" variant=" OTPrimary">Save</b-button>
                </b-col>
            </b-row>
            <b-row>
                <b-col cols="12" md="6">
                    <otif-tagInput
                        name="follow"
                        label="Follow These People"
                        description="Follow the tweets of one or more accounts"
                        placeholder="Please provide Twitter account name(s)"
                        :preInput="userPrefix"
                        v-model="follow">
                    </otif-tagInput>
                </b-col>
                <b-col cols="12" md="6">
                    <otif-tagInput
                        placeholder="Please provide  terms or #hashtags"
                        name="phrases_to_track"
                        label="Phrases to Track"
                        description="Only collect tweets that contain these phrases"
                        v-model="phrases_to_track">
                    </otif-tagInput>
                </b-col>
            </b-row>
            <b-row>
                <b-col  cols="12" md="6">
                    <otif-select
                         name="language"
                         label="Languages"
                         description="Only collect tweets in these languages (leave blank to disable)"
                         v-model="language"
                         :multiple="true"
                         placeholder="Choose languages"
                         :values="languages"
                         id="OTMultiLangSelector">
                    </otif-select>
                </b-col>
            </b-row>
            <b-row>
                <b-col  cols="12" md="6">
                    <otif-select
                        name="filter_level"
                        label="Filter Level"
                        v-model="filter_level"
                        :values="filterLevels">
                    </otif-select>
                </b-col>
            </b-row>
            <b-row>
                <b-col>
                    <h3>Locations</h3>
                    <p>
                        Locations are specified as a list of longitude, latitude pairs specifying a set of bounding boxes to filter Tweets by. Each bounding box should be specified as a pair of longitude and latitude pairs, with the southwest corner of the bounding box coming first.
                    </p>
                </b-col>
            </b-row>
            <b-row>
                <b-col>
                    <otif-table
                        @change="onLocationsChange"
                        :columns="locationColumns"
                        :paginated="false"
                        :validations="tableValidations"
                        :rows="locations">
                        <template slot="empty">
                            No coordinates entered.
                        </template>
                    </otif-table>
                </b-col>
            </b-row>
        </b-form>
    </b-col>
</b-row>

</template>

<script>

import languages from '@/languages';

import { latitude, longitude } from '@/validation/coordinates.js';
import { required } from 'vuelidate/lib/validators';
import { resourceMapper } from '@/utils/resourceMapper.js';

export default {

    data() {
        return {
            tableValidations: {
                corner_latitude: {
                    required,
                    latitude
                },
                corner_longitude: {
                    required,
                    longitude
                },
                diag_corner_latitude: {
                    required,
                    latitude
                },
                diag_corner_longitude: {
                    required,
                    longitude
                }
            },
            locationColumns: [{
                name: 'corner_latitude',
                label: 'Southwest Latitude',
                invalidMessage: "Latitude must be between -90 and 90"
            },{
                name: 'corner_longitude',
                label: 'Southwest Longitude',
                invalidMessage: "Longitude must be between -180 and 180"
            },{
                name: 'diag_corner_latitude',
                label: 'Northeast Latitude',
                invalidMessage: "Latitude must be between -90 and 90"
            },{
                name: 'diag_corner_longitude',
                label: 'Northeast Longitude',
                invalidMessage: "Longitude must be between -180 and 180"
            }],
            filterLevels: [{
                label: 'None',
                value: 'none'
            },{
                label: 'Low',
                value: 'low'
            },{
                label: 'Medium',
                value: 'medium'
            }],
            languages: languages
        }
    },

    props: ['job'],

    computed: {
        locations() {
            const rows = this.job.get('job_criteria.locations', []).map((loc) => {
                return [loc.corner.latitude, loc.corner.longitude, loc.diagonal_corner.latitude, loc.diagonal_corner.longitude];
            });

            return rows;
        },
        ...resourceMapper([{
            propertyName: 'follow',
            attributeName: 'job_criteria.follow',
            defaultValue() { return []; }
        },{
            propertyName: 'phrases_to_track',
            attributeName: 'job_criteria.phrases_to_track',
            defaultValue() { return []; }
        },{
            propertyName: 'filter_level',
            attributeName: 'job_criteria.filter_level',
            defaultValue: 'none'
        },{
            propertyName: 'language',
            attributeName: 'job_criteria.language',
            defaultValue() { return []; }
        }], 'job', 'stream-criteria')

    },

    methods: {
        userPrefix(tag) {
            if (!tag.startsWith('@')) {
                return '@' + tag;
            }
        },
        onLocationsChange($e) {
            const locations = $e.rows.map((row) => {
                return {
                    corner: {
                        latitude: parseFloat(row[0]),
                        longitude: parseFloat(row[1])
                    },
                    diagonal_corner: {
                        latitude: parseFloat(row[2]),
                        longitude: parseFloat(row[3])
                    }
                };
            });
            this.job.set('job_criteria.locations', locations);

            this.$eventBus.$emit('section-changed', 'stream-criteria');
        },

        onSubmit($e) {
            $e.preventDefault();

            const criteria = JSON.parse(JSON.stringify(this.job.get('job_criteria', {})));

            criteria['count'] = 0;
            criteria['type'] = 'Twitter Stream';

            if (!criteria['locations']) {
                criteria['locations'] = [];
            }

            this.job.set('job_criteria', criteria);

            this.job.save()
            .then(() => {
                this.$eventBus.$emit('job-saved');
            });
        }
    },

    mounted() {
        var breadcrumbs = [{
            name: 'jobs',
            meta: { label: 'Jobs' }
        },{
            name: 'job-edit',
            meta: { label: this.job.get('job_name') },
            params: { job_id: this.job.id }
        },{
            name: 'stream-criteria',
            meta: { label: this.job.get('job_type') },
            params: { job_id: this.job.id }
        }];

        this.$store.commit('breadcrumbs', breadcrumbs);
    }
};

</script>
